import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { toTwoDecimals } from '../../plugins';

/**
 * PickupScheduleForm Component
 * Handles the pickup date and amount input fields
 * Memoized to prevent unnecessary re-renders when parent state changes
 */
const PickupScheduleForm = React.memo(({
    date,
    setDate,
    startDate,
    filteredDays,
    totalPrice,
    handlePriceChange,
    note,
    setNote,
    remainingChars,
    maxNoteLength,
    order,
    isRescheduling
}) => {
    return (
        <>
            <h4 className='mb-4'>{isRescheduling ? 'Update' : 'Schedule Pickup'}</h4>
            <div className='check-card mb-4 payment-pickup-card'>
                <Row>
                    <Col md={6} xs={12} className='mb-3'>
                        <Form.Group className='d-flex flex-column'>
                            <Form.Label className='mb-2'>
                                Desired Pickup Date *
                            </Form.Label>
                            <div className='mb-2'>
                                <DatePicker
                                    selected={date}
                                    minDate={startDate}
                                    onChange={(selectedDate) => setDate(selectedDate)}
                                    filterDate={(date) =>
                                        filteredDays.includes(date.getDay())
                                    }
                                    placeholderText='Select a pickup date'
                                    className="form-control"
                                    required
                                />
                            </div>
                            <Form.Text className="text-muted d-block">
                                Available dates based on your location
                            </Form.Text>
                        </Form.Group>
                    </Col>

                    <Col md={6} xs={12} className='mb-3'>
                        <Form.Group className='d-flex flex-column'>
                            <Form.Label className='mb-2'>
                                Pickup Amount ($) *
                            </Form.Label>
                            <div className='mb-2'>
                                <Form.Control
                                    type='text'
                                    value={totalPrice}
                                    onChange={handlePriceChange}
                                    placeholder={`Enter the amount (max: $${order.DueAmount?.value ? toTwoDecimals(Number(order.DueAmount.value)) : '0.00'})`}
                                    required
                                    className='form-control'
                                    disabled={isRescheduling}
                                />
                            </div>
                            <Form.Text className="text-muted d-block">
                                {order.DueAmount?.value
                                    ? `Maximum amount: $${toTwoDecimals(Number(order.DueAmount.value))}`
                                    : 'Enter the pickup amount'}
                            </Form.Text>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <Form.Group className='form-group-delivery-note'>
                            <Form.Label>
                                Pickup Notes (Optional)
                            </Form.Label>
                            <Form.Control
                                as='textarea'
                                value={note}
                                rows={3}
                                maxLength={maxNoteLength}
                                onChange={(event) => setNote(event.target.value)}
                                placeholder='Leave any special instructions or notes for pickup'
                                className='mb-0'
                            />
                            <Form.Text className="text-muted float-right">
                                {remainingChars} characters left
                            </Form.Text>
                        </Form.Group>
                    </Col>
                </Row>
            </div>
        </>
    );
});

PickupScheduleForm.displayName = 'PickupScheduleForm';

export default PickupScheduleForm;

